import { useParams } from 'react-router';

export function JobDetailPage() {
  const { id } = useParams();
  
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Job Details</h1>
      <p className="mt-2 text-gray-600">Job ID: {id}</p>
      {/* Job detail implementation will go here */}
    </div>
  );
}